import { render, staticRenderFns } from "./AccountManageEx.vue?vue&type=template&id=97a4be8a&scoped=true"
import script from "./AccountManageEx.vue?vue&type=script&lang=js"
export * from "./AccountManageEx.vue?vue&type=script&lang=js"
import style0 from "./AccountManageEx.vue?vue&type=style&index=0&id=97a4be8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a4be8a",
  null
  
)

export default component.exports